import { Bank } from '@liveauctioneers/hammer-ui-core/icons';
import { BodySecondary, H3 } from '@liveauctioneers/hammer-ui-core/text';

import BankAccountOnFileWithPlaidVerifyContainer from '@/components/Plaid/BankAccountOnFileWithPlaidVerifyContainer';
import LaPlaidLink from '@/components/Plaid/LaPlaidLink';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    bankAccountToDisplay: React.ComponentProps<typeof BankAccountOnFileWithPlaidVerifyContainer>['bankAccount'];
    onBankAccountDelete: (bankAccountId: number, plaidAccountId?: string) => void;
};

// Component on account settings that will either show an account, or the add account text
export const BankAccountOnFileWrapper = ({ bankAccountToDisplay, onBankAccountDelete }: Props) => {
    const formatMessage = useAppFormatMessage();

    return (
        <>
            {Boolean(bankAccountToDisplay) && bankAccountToDisplay.enabled ? (
                <BankAccountOnFileWithPlaidVerifyContainer
                    bankAccount={bankAccountToDisplay}
                    deleteAccount={() =>
                        onBankAccountDelete(bankAccountToDisplay.bankAccountId, bankAccountToDisplay.plaidAccountId)
                    }
                    deleteAccountLinkText="Remove"
                />
            ) : (
                <div className="m-0 border border-border-secondary p-lg">
                    <div className="flex items-center">
                        <Bank
                            color="secondary"
                            size="lg"
                            style="duotone"
                        />
                        <div className="ml-md flex flex-col">
                            <H3 className="mb-2xs">{formatMessage(['accountSettings', 'bankAccountTitle'])}</H3>
                            <BodySecondary>{formatMessage(['accountSettings', 'bankDetails'])}</BodySecondary>
                        </div>
                    </div>
                    <LaPlaidLink />
                </div>
            )}
        </>
    );
};
